<template>
  <div class="animated fadeIn">
    <b-card border-variant="primary" id="list">
      <template slot="header">
        <i class='fa fa-align-justify'></i> Group List
      </template>
      <!-- detail search start -->
      <b-card v-show="so.adv">
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_date"> Join_at
                <b-button size="sm" variant="info" @click="set_sd('')"><i class="fa fa-remove"></i></b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1d')">-1D</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1w')">-1W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('-1m')">-1M</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('w')">W</b-button>
                <b-button size="sm" variant="primary" @click="set_sd('m')">M</b-button>
              </label>
              <b-form inline>
                <date-picker @change="refresh" v-model="so.opt.joined_at_sd" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
                ~
                <date-picker @change="refresh" v-model="so.opt.joined_at_ed" style="width: 140px" :lang="custom.lang.en" :confirm="false" :first-day-of-week="1"></date-picker>
              </b-form>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group>
              <label for="opt_group">Service</label>
              <br>
              <v-select v-model="so.opt['service']" :options="codes.service_name"></v-select>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6" v-if="partner">
            <b-form-group>
              <label for="opt_groupname">Name</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_groupname" v-model="so.opt['groupname']"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group>
              <label for="opt_E-mail">E-Mail</label>
              <b-form-input @keydown.enter="refresh" type="text" id="opt_E-mail" v-model="so.opt['email']"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <label for="ph_search_alive">Alive</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_alive']" @change="change_alive" />
            </b-form-group>
          </b-col>
          <b-col md="3">
            <label for="ph_search_del">Delete</label>
            <b-form-group>
              <c-switch color="info" label size="sm" v-model="so.opt['is_del']" @change="change_del" />
            </b-form-group>
          </b-col>
        </b-row>
        <!-- <b-row>
          <b-col md="4">
            <b-form-group>
              <label for="opt_country">Country</label>
              <v-select v-model="so.opt['country']" :options="codes.country"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_timezone">Timezone</label>
              <v-select v-model="so.opt['timezone']" :options="codes.timezone"></v-select>
            </b-form-group>
          </b-col>
          <b-col md="4">
            <b-form-group>
              <label for="opt_language">Language</label>
              <v-select v-model="so.opt['language']" :options="codes.language"></v-select>
            </b-form-group>
          </b-col>
        </b-row> -->
        <b-row>
          <b-col md="12">
            <label for="ph_search_opt_type">Match Type</label>
            <b-form-group>
              <b-form-radio-group id="ph_search_opt_type" v-model="so.opt['match_type']" name="ph_search_opt_type">
                <b-form-radio value="and">[AND]:Match all</b-form-radio>
                <b-form-radio value="or">[OR]:Match at least one</b-form-radio>
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-form-group class="float-right">
          <b-button size="sm" variant="success" @click="refresh"> Search </b-button>
          <b-button size="sm" variant="warning" @click="reset"> Reset </b-button>
          <b-button size="sm" variant="secondary" @click="search_opt"> Close </b-button>
        </b-form-group>
      </b-card>
      <!-- detail search end -->
      <hr>
      <b-row>
        <b-col sm="2" v-if="view_detail !== false">
          <b-badge variant="primary">
            TOTAL : {{model.enable + model.disable}}
          </b-badge>
          <br>
          <b-badge variant="success">
            USE : {{model.enable}}
          </b-badge>
          <br>
          <b-badge variant="warning">
            Deleted : {{model.disable}}
          </b-badge>
        </b-col>
        <b-col :sm="view_detail !== false ? 10 : 12" class="md-10">
          <b-input-group size="sm">
            <b-input-group-prepend>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-refresh"></i></b-btn>
              <b-btn variant="outline-secondary" @click="reset()"><i class="fa fa-remove"></i></b-btn>
              <b-dropdown :disabled="so.adv" :text="so.skt || 'Search'" size="sm" variant="outline-secondary">
                <b-dropdown-item size="sm" @click="so.sk='service';so.skt='Service'; so.sv = '';">Service</b-dropdown-item>
                <b-dropdown-item size="sm" @click="so.sk='groupname';so.skt='Name'; so.sv = '';">Name</b-dropdown-item>
              </b-dropdown>

              <v-select :disabled="so.adv" v-if="so.sk == 'service'" @change="refresh" v-model="so.sv" :options="codes.service_name"></v-select>
              <!-- <select  v-model="so.sv"  :option="codes.service_name">
                <option value="true">Verified</option>
                <option value="false">Not Verified</option>
              </select> -->
            </b-input-group-prepend>
            <b-form-input v-if="so.sk != 'service'" :disabled="so.adv" v-model="so.sv" @keyup.enter="refresh()"></b-form-input>
            <b-input-group-append>
              <b-btn variant="outline-secondary" @click="refresh()"><i class="fa fa-search"></i></b-btn>
              <b-btn variant="outline-secondary" @click="search_opt"><i class="fa" :class="{'fa-search-plus': !so.adv, 'fa-search-minus': so.adv }"></i></b-btn>
            </b-input-group-append>
          </b-input-group>
          <br>
          <b-input-group size="sm">
            <select v-model="so.perPage" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Show count : Default 15</option>
              <option value=10>10</option>
              <option value=50>50</option>
              <option value=100>100</option>
            </select>

            <select v-if="auto_refresh" v-model="sync.interval" @change="refresh" style="margin-right:15px">
              <option disabled value="15">Please select interval : Default 15</option>
              <option value=10>10</option>
              <option value=30>30</option>
              <option value=60>60</option>
              <option value=300>300(5 min)</option>
            </select>
            <span v-if="auto_refresh" class="float-right" style="margin-right:15px">
              <i :class="`fa fa-refresh ${th && sync.stop ? 'fa-spin' : ''}`" style="margin-right:5px"></i>
              <b-btn @click="pause" size="sm" variant="warning">
                {{!sync.stop ? "Auto refresh"  : "Pause"}}
              </b-btn>
            </span>
            <div>
              <b-button v-if="has_permissions()" size="sm" variant="success" @click="addWithPartner"> New Registration </b-button>
            </div>
            <b-checkbox @change="refresh" class="ml-3 mt-1" v-model="hide_del">Hide deleted</b-checkbox>
          </b-input-group>
        </b-col>
      </b-row>
      <hr>
      <b-table hover striped small responsive="sm" foot-clone ref="_list"
        show-empty empty-text="not found"
        :items="getItems" :fields="fields" :current-page="so.currentPage" :per-page="so.perPage" :sortBy="so.sk">
        <template slot="id" slot-scope="row">{{startRow - row.index}}</template>
        <template slot="joined_at" slot-scope="row">{{row.item.joined_at | sdate }}</template>
        <template slot="groupname" slot-scope="row">
          <span v-if="row.item.language">[{{row.item.language.toUpperCase()}}]</span>
          [User : {{row.item.count || 0}}]
          <del v-if="row.item.is_del">{{row.item.groupname }}</del>
          <span v-else>{{row.item.groupname }}</span>
        </template>
        <template slot="country" slot-scope="row">{{row.item.country }}</template>
        <template slot="service" slot-scope="row">
          <b-badge  :variant="row.item.service === 'Basic' ? 'info' : 'success'"> {{row.item.service}} </b-badge>
        </template>
        <template slot="is_alive" slot-scope="row">
          <c-switch color="info" label size="sm" v-model="row.item.is_alive" :disabled="true" />
        </template>
        <template slot="count" slot-scope="row">{{row.item.count | number }}</template>
        <template slot="func" slot-scope="row">
          <b-btn @click="detail(row.item)" size="sm" variant="outline-primary">
            <!-- {{(model && model.id == row.item.id ? 'Selected' : 'Detail')}} -->
            {{enable_new !== false ? 'Detail' : 'Select'}}
          </b-btn>
        </template>
      </b-table>
      <hr>
      <b-row>
        <b-col class="md-8">
          <b-pagination size="sm" :total-rows="getRowCount()" :per-page="so.perPage" v-model="so.currentPage" prev-text="Prev" next-text="Next"  />
        </b-col>
      </b-row>
    </b-card>
    </div>
</template>

<script>
import { Api } from '@/service';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import codes from '@/codes';
import { Switch as cSwitch } from '@coreui/vue';
import moment from 'moment-timezone';
import vSelect from 'vue-select';
import auth from '@/service/auth';

let default_opt = function() {
  return {
    perPage: 15,
    currentPage: 1, totalRows: 0,
    sk: '', sv: '', skt: '', opt : {}, adv : false
  }
}

export default {
  components: { DatePicker, cSwitch, vSelect },
  name : "groupList",
  props : ["auto_refresh", "enable_new", "view_detail", "partner", "addPartner"],
  data: () => ({
    auth,
    hide_del : true,
    custom,
    codes,
    so : default_opt(),
    model : { total : 0, enable : 0, disable : 0 },
    sync : { interval : 15, stop : false, th : undefined },
  }),
  computed: {
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      let f = [
        { key: 'id', label: 'No.', sortable: false, thStyle: 'width: 10%' },
        { key: 'joined_at', label: 'Join_at', sortable: true },
        { key: 'groupname', label: 'Name', sortable: true },
        { key: 'email', label: 'E-Mail', sortable: true },
        { key: 'service', label: 'Service', sortable: false },
        { key: 'is_alive', label: 'Active', sortable: false },
        { key: 'func', label: 'Action', sortable: false, thStyle: 'width: 10%'  },
      ]

      if(!this.view_detail) { f.splice(0, 1) }
      // console.log(this.view_detail, f)
      return f;
    }
  },
  methods: {
    has_permissions() { return this.enable_new !== false && ((this.partner && this.partner.id) || auth.profile.permissions.toLowerCase() != 'sales')  },
    change_del($event) { if($event == true || $event == false) { this.so.opt['is_del'] = $event; this.refresh(); } },
    change_alive($event) { if($event == true || $event == false) { this.so.opt['is_alive'] = $event; this.refresh(); } },
    addWithPartner() {
      if(this.addPartner === true) {
        this.$router.push({ name: 'group', params: { id : this.$route.params.id, tag : "partner" } })
      } else {
        this.$router.push({ name: 'group', params: { id : 'add' } })
      }
    },
    set_sd(v, k = 'joined_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt);
    },
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['joined_at_ed'] = moment();
        this.so.opt['service'] = "Basic";
        this.so.opt['match_type'] = 'and';
        this.so.opt['is_verified'] = 'true';

        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(k == 'permissions') {
        return { name : k, value : v, op : '=' };
      } else if(v == 'false' || v == 'true' || (k.length > 2 && k.substring(0, 2) == "is")) {
        return { name : k, value : v == false ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    refresh() { this.$refs._list.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    getItems(ctx) { return this.load(ctx); },
    load(ctx = {}) {
      let and = [  ]
      let so = {
        target : 'group', cmd : 'list',
        body : {
          sort : [{ name : "is_del", op : "asc" }, { name : "id", op : "desc" }],
          or : [],
          and : and
        },
        offset : (this.so.currentPage-1 || 0) * Number(this.so.perPage), limit: Number(this.so.perPage), // 10 은 나중에 변수 처리해야함.
      }

      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.so.sk && (this.so.sv || '').trim()) { so.body.and.push({ name : this.so.sk, value : `%${this.so.sv}%`, op : 'like' } ); }
      if(this.partner) { so.body.and.push({ name : "partner_id", Value : this.partner.id, op : "=" }) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }); }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'is_verified':
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
            case 'joined_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'joined_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "notice"); break; }
              cond = { name : k[i].slice(0, 9), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      return Api.Manager(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    summary() {
      Api.Manager({ target : 'group', cmd : 'summary', body : Object.assign({}, this.partner ? { partner_id: this.partner.id } : { ts : new Date().getTime() } ) })
        .then(rs => { this.model = Object.assign(this.model, { enable : rs.body.enable, disable : rs.body.disable }) })
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    detail(item) {
      this.view_detail == false ? this.$emit("select", item) : this.$router.push({ name : 'group', params : { id : item.id } })
    },
    add: async function() {
      try {
        if(!(this.model.groupname || '').trim()) { return this.$toastr.e('Group Name is Require.'); }

        let rs = await Api.Manager_Call('group', this.model.id ? 'update' : 'insert', this.model);
        if(!rs.error) {
          this.$toastr.s('Saved', this.$route.name);
        } else {
          this.$toastr.e('Save', "failed");
        }
      } catch(e) { this.$toastr.e(e.data ? e.data.message ? e.data.message : e : e.statusText); this.list()}
    },
  },
  created() { console.log('group.list.vue', 'created'); },
  destroyed() { console.log('group.list.vue', 'destroyed'); },
  mounted() { console.log('group.list.vue', 'mounted');
    if(this.view_detail !== false) { setTimeout(this.summary, 1000) }
  },
}
</script>
